import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import AddVehicle from './AddVehicle';
import {
	lookupPermission,
	lookupIsAdmin,
	vsearch,
} from '../../actions/lookups';
import {
	setIncludeSold,
	setIncludeGroupInventory,
} from '../../actions/apiSetInfo';
import {
	getIncludeGroupInventory,
	setIncludeGroupInventory as persistIncludeGroupInventory,
} from '../../utils/includeGroupInventory';

class SearchBar extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			search: '',
			errors: {},
			isLoading: false,
			include_sold: this.props.include_sold,
			include_group_inventory: this.props.include_group_inventory,
		};
		this.onChange = this.onChange.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onClickSold = this.onClickSold.bind(this);
		this.onClickGroupInventory = this.onClickGroupInventory.bind(this);
		this.preventSearchBlur = this.preventSearchBlur.bind(this);
		this.onFocus = this.onFocus.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	componentDidMount() {
		this.hydrateGroupInventoryPreference();
	}

	componentDidUpdate(prevProps) {
		const prevDb = prevProps.installation && prevProps.installation.database;
		const nextDb = this.props.installation && this.props.installation.database;
		if (prevDb !== nextDb) {
			this.hydrateGroupInventoryPreference();
		}
	}

	hydrateGroupInventoryPreference() {
		const database = this.props.installation && this.props.installation.database;
		if (!database) return;
		const value = getIncludeGroupInventory(database);
		this.setState({ include_group_inventory: value });
		this.props.setIncludeGroupInventory(value);
	}

	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		if (this.props.installation.database === 'marhofer') {
			if (e.target.value.length >= 7) {
				this.props.vsearch(e.target.value.toLowerCase(), this.state.include_sold);
			}
		} else if (e.target.value.length >= 5) {
			this.props.vsearch(e.target.value.toLowerCase(), this.state.include_sold);
		}
	}

	onClickSold() {
		this.setState({ include_sold: !this.state.include_sold });
		this.props.setIncludeSold(!this.state.include_sold);
	}

	onClickGroupInventory() {
		const database = this.props.installation && this.props.installation.database;
		const next = !this.state.include_group_inventory;
		this.setState({ include_group_inventory: next });
		// Dispatch before vsearch — thunk reads include_group_inventory from Redux.
		this.props.setIncludeGroupInventory(next);
		if (database) {
			persistIncludeGroupInventory(database, next);
		}
		const term = (this.state.search || '').trim();
		if (term.length >= 3) {
			this.props.vsearch(term.toLowerCase(), this.state.include_sold);
		}
	}

	/** Keep focus in the search input so toggle clicks do not fire a stale onBlur vsearch. */
	preventSearchBlur(e) {
		e.preventDefault();
	}

	onBlur(e) {
		if (e.target.value.length >= 4) {
			this.props.vsearch(e.target.value.toLowerCase(), this.state.include_sold);
		}
	}

	onKeyDown(e) {
		if (e.key === 'Enter' && e.target.value.length >= 3) {
			this.props.vsearch(e.target.value.toLowerCase(), this.state.include_sold);
		}
	}

	onFocus(e) {
		this.setState({ [e.target.name]: '' });
	}

	render() {
		let vehicle_create = '';
		let advanced_search = false;
		const include_sold = [];
		const include_group = [];
		const isGroup = (this.props.related_installations || []).length > 1;

		include_sold.push(<div key="search-sold" title={'Includes Sold Vehicles In Search'} className={this.state.include_sold ? 'input-group-append success' : 'input-group-append info'} onMouseDown={this.preventSearchBlur} onClick={this.onClickSold}>
			<span className={this.state.include_sold ? 'input-group-text success input-sm' : 'input-group-text default strike'}>Include Sold</span>
		</div>);

		if (isGroup) {
			include_group.push(<div key="search-group-inventory" title={'Include vehicles from all stores in this group'} className={this.state.include_group_inventory ? 'input-group-append success' : 'input-group-append info'} onMouseDown={this.preventSearchBlur} onClick={this.onClickGroupInventory}>
				<span className={this.state.include_group_inventory ? 'input-group-text success input-sm' : 'input-group-text default strike'}>Include Group Inventory</span>
			</div>);
		}

		if (this.props.lookupPermission('vehicle_create') || this.props.lookupIsAdmin()) {
			vehicle_create = <AddVehicle key="create-add-vehicle" />;
		}

		if (this.props.lookupPermission('advanced_search') || this.props.lookupIsAdmin()) {
			advanced_search = <div className="input-group" key="search-group">
				<input type="text" onKeyDown={this.onKeyDown} className="form-control search-input input-sm" placeholder="Search Stock, Vin, Make, Model" onFocus={this.onFocus} onChange={this.onChange} name="search" value={this.state.search} />
				{include_sold}
				{include_group}
				{vehicle_create}
                     </div>;
		}

		return (
			<div className="input-group pad-left-1">
				{advanced_search || vehicle_create}
			</div>
		);
	}
}

const mappedActions = {
	lookupPermission,
	lookupIsAdmin,
	vsearch,
	setIncludeSold,
	setIncludeGroupInventory,
};

function mapStateToProps(state) {
	return {
		include_sold: state.settings_nav.include_sold,
		include_group_inventory: state.settings_nav.include_group_inventory,
		installation: state.settings_dealerships.installation,
		related_installations: state.settings_dealerships.related_installations,
	};
}
export default connect(mapStateToProps, mappedActions)(SearchBar);
